// @ts-strict-ignore
import React from 'react'
import styled from 'styled-components/native'
import { SafeAreaView } from 'react-native-safe-area-context'

import I18n from 'APP/I18n'
import Button from 'APP/Converse/Button'
import LogoHeader from 'APP/Components/LogoHeader'
import Card from 'APP/Converse/Card'
import { Images } from 'APP/Themes'

const Container = styled(SafeAreaView)`
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
  background-color: ${({ theme }) => theme.colors.background};
`

const ContentCard = styled(Card)`
  max-width: 550px;
  width: 100%;
  align-items: start;
  gap: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
`

const VerifyEmailSuccessScreen = ({ navigation }) => {
  return (
    <Container>
      <ContentCard>
        <LogoHeader
          source={Images.logoBlue}
          title={I18n.t('VerifyEmailSuccessScreen.title')}
          subtitle={I18n.t('VerifyEmailSuccessScreen.subtitle')}
        />
        <Button
          testID="CONTINUE_BTN"
          analyticsName="VerifyEmailSuccessScreen.continueButtonLabel"
          onPress={navigation.goBack}
          title={I18n.t('VerifyEmailSuccessScreen.continueButtonLabel')}
          widthVariant="full"
        />
      </ContentCard>
    </Container>
  )
}

export default VerifyEmailSuccessScreen
